import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import BaseButton from "../../Internals/BaseButton/BaseButton";
import closeIcon from "../../../assets/imgs/closeWithCircle.svg";
import playerIcon from "../../../assets/imgs/Player_place_holder-09.svg";

class SelectPlayerButton extends Component {
  state = {
    hover: false,
    clicked: this.props.isSelected
  };

  componentDidUpdate(prevProps, prevState) {
    const { isSelected } = this.props;
    if (isSelected !== prevState.clicked) {
      this.setState({ clicked: isSelected });
    }
  }

  onMouseOver = () => {
    if (!this.props.disabled) {
      this.setState({ hover: true });
    }
  };

  onMouseOut = () => {
    if (!this.props.disabled) {
      this.setState({ hover: false });
    }
  };

  onClick = () => {
    this.setState(prevState => ({ clicked: !prevState.clicked }));
    if (this.props.onClick) {
      this.props.onClick(this.props.player);
    }
  };

  onDelete = e => {
    e.stopPropagation();
    this.props.onDelete(this.props.player);
  };

  render() {
    const {
      player,
      dontChangeColorOnClick,
      isSelected,
      showDelete,
      size,
      hasHover,
      ...props
    } = this.props;

    const btnCssClass =
      this.state.clicked && !dontChangeColorOnClick
        ? `selectPlayerButton__round-btn selectPlayerButton__round-btn--${size} selectPlayerButton__round-btn--clicked`
        : `selectPlayerButton__round-btn selectPlayerButton__round-btn--${size}`;

    const numberButton = (
      <BaseButton
        className={btnCssClass}
        {...props}
        onMouseOver={this.onMouseOver}
        onClick={this.onClick}
      >
        {player.playerNumber !== null ? (
          player.playerNumber
        ) : (
          <span
            style={{
              fontSize: "12px",
              display: "flex",
              justifyContent: "center"
            }}
          >
            N/A
          </span>
        )}
      </BaseButton>
    );

    const avatarButton = (
      <div
        className="selectPlayerButton__avatar-container"
        onClick={this.onClick}
      >
        <div className="selectPlayerButton__round-img">
          <img src={player.avatar !== null ? player.avatar : playerIcon} />
        </div>
        <p>{player.fullName}</p>
      </div>
    );

    return (
      <div
        className={`selectPlayerButton__container selectPlayerButton__container--${size}`}
        onMouseLeave={this.onMouseOut}
      >
        {hasHover ? (
          <Fragment>
            {this.state.hover ? avatarButton : numberButton}
            {this.state.hover && showDelete ? (
              <img
                src={closeIcon}
                className="selectPlayerButton__deleteButton"
                onClick={this.onDelete}
                onMouseLeave={this.onMouseOut}
              />
            ) : null}
          </Fragment>
        ) : (
          numberButton
        )}
      </div>
    );
  }
}

SelectPlayerButton.propTypes = {
  /** player obj with params number avatar name */
  player: PropTypes.object.isRequired,
  /** if true button color dont change on click */
  dontChangeColorOnClick: PropTypes.bool,
  /** if true delete button is shown of up right side */
  showDelete: PropTypes.bool,
  /** delete function */
  onDelete: PropTypes.func,
  /** button size : small, medium , large */
  size: PropTypes.string,
  hasHover: PropTypes.bool
};
SelectPlayerButton.defaultProps = {
  hasHover: true,
  size: "medium"
};

export default SelectPlayerButton;
